var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.cssGauge = function (widget, chart, data, metadata) {
    var debugWidget = widget.data('id') === '79333489-e2fa-41c6-bd9f-f8204072f2f4' && window.location.hostname === 'localhost';
    
    var LABELS_BOTTOM = 'bottom'
        , LABELS_TOP = 'top';

    var errorMessage = MDB.loadResourceString('GenericWidget_InvalidDataErrorMessage') + ' ',
        validatedData = validateData(),
        value = (validatedData && validatedData.config) ? validatedData.config.value : null;

    if(validatedData && validatedData.config){
        $.extend(metadata.KendoConfig, validatedData.config);
    }

    var min = metadata.KendoConfig.min,
        max = metadata.KendoConfig.max,
        fractionMaxDisplay = metadata.KendoConfig.fractionMaxDisplay,
        drawSingleBlock = metadata.KendoConfig.drawSingleBlock,
        drawFullBlocks = metadata.KendoConfig.drawFullBlocks,
        borderWidth = metadata.KendoConfig.borderWidth || 25,
        invertPointerDirection = min > max,
        labelType = metadata.KendoConfig.labelType,
        labelsPosition = metadata.KendoConfig.labelsPosition || LABELS_TOP,
        invertColors = metadata.KendoConfig.invertColors,
        minorUnit = metadata.KendoConfig.minorUnit,
        majorUnit = metadata.KendoConfig.majorUnit,
        imageUrl = document.location.origin + '/Widget/GetImage?filename=',
        colorConfig = metadata.KendoConfig.colorConfig,
        tickType = metadata.KendoConfig.tickType;
    
    if (validatedData && validatedData.colorConfigs && validatedData.colorConfigs.length) {
        colorConfig = colorConfig || [];
        colorConfig.push.apply(colorConfig, validatedData.colorConfigs);
    }
    if(invertPointerDirection) {
        min = metadata.KendoConfig.max;
        max = metadata.KendoConfig.min;
    }

    if (fractionMaxDisplay === undefined){
        fractionMaxDisplay = max;
    }
    
    //Fallback to default configuration
    if(!colorConfig || !Object.keys(colorConfig).length) {
    	colorConfig = [
            {start: 66, color: (invertColors ? '#DC1E33' : '#ABC437')},
            {start: 33, color: '#EE812D'},
            {start: 0, color: (invertColors ? '#ABC437' : '#DC1E33')}
        ];
    }

    if (majorUnit || minorUnit) {
        //Default to percent for legacy reasons
        var isPercentageType = tickType === undefined || tickType === 'percent'
            , tickMin = isPercentageType ? 0 : min
            , tickMax = isPercentageType ? 100 : max;//Math.max(fractionMaxDisplay, max);

        //Only bottom labels are supported for tick widgets
        labelsPosition = LABELS_BOTTOM;

        //0 - 100%
        var minorRange = !!minorUnit ? _.range(tickMin, tickMax + minorUnit, minorUnit) : [];
        var majorRange = !!majorUnit ? _.range(tickMin, tickMax + majorUnit, majorUnit) : [];
        
        var tickRanges = _.orderBy(_.union(majorRange, minorRange));
        
        if (tickRanges.length){
            var colorConfigClone = _.cloneDeep(colorConfig);    

            _.forEach(tickRanges, function (tickValue) {
                var tickPercentage = isPercentageType ? tickValue : (tickValue / tickMax) * 100
                    , colorForPercentage = findColorConfigOrDefault(tickPercentage / 100);
                
                var isMaxTick = tickValue === max;

                var tickConfig = {
                    //Due to the way rendering is handled force the tick at the absolute max to start 1 position before it
                    start: isMaxTick ? (tickPercentage - 1) : tickPercentage,
                    color: '#000',

                    isTick: true,
                    tickValue: tickValue,
                    isMajorTick: majorRange.indexOf(tickValue) !== -1
                };
                
                var beforeClone = _.cloneDeep(colorForPercentage);
                var afterClone = _.cloneDeep(colorForPercentage);

                beforeClone.start = tickConfig.start - 1;
                afterClone.start = tickConfig.start + 1;

                //Only push an item before if the color is the same; otherwise the tick config can be considered the boundary
                if (findColorConfigOrDefault(beforeClone.start / 100).color === beforeClone.color) {
                    colorConfigClone.push(beforeClone);
                }
                
                if (tickConfig.start <= 100){
                    colorConfigClone.push(tickConfig);
                    colorConfigClone.push(afterClone);    
                }
            });

            colorConfig = colorConfigClone;    
        }
    }
    
    //The guage animation bugs exactly 180 degrees, so we use the closest possible value
    var maxDegrees = 179.99999;

    if (!isNaN(value)) {
        setTimeout(drawWidget, 0);
    }

    function validateData() {
        if (data && data.length) {
            var keys = Object.keys(data[0]);

            return {
                config: validateConfig(data[0][keys[0]]),
                colorConfigs: _.map(_.without(keys, keys[0]), function (key) {
                    return validateColorConfig(data[0][key]); 
                })
            };
        }

        errorMessage += MDB.loadResourceString('Gauge_InvalidDataStructure_ErrorMessage');
        showError(errorMessage);
        return null;
    }

    function validateConfig(conf){
        if($.isNumeric(conf)){
            conf = { value: conf };
        }
        
        if (_.isString(conf)) {
            conf = JSON.parse(conf);
        }
        
        conf.value = validateValue(conf.value);
        
        return conf;
    }

    function validateColorConfig(conf) {
        if (_.isString(conf)) {
            conf = JSON.parse(conf);
        }

        if (conf) {
            _.forEach(_.keys(conf), function (key) {
                var lowerFirstKey = _.lowerFirst(key);

                if (key !== lowerFirstKey) {
                    conf[_.lowerFirst(key)] = conf[key];
                    delete conf[key];
                }
            });

            if ($.isNumeric(conf.start) && conf.color) {
                return conf;
            }
        }

        errorMessage += 'Color config should contain a positive \'start\' property and a \'color\' property';
        showError(errorMessage);

        return null;
    }

    function validateValue(val) {
        if (!$.isNumeric(val)) {
            errorMessage += sprintf(MDB.loadResourceString('Gauge_InvalidDataType_ErrorMessageFormat'), val);
            showError(errorMessage);
            return null;
        }

        return val;
    }

    function showError(message) {
        widget.find('.loading-box').hide();
        chart.show().find('.no-data-message').remove();
        $('<div />', { 'class': 'no-data-message info' }).text(message).appendTo(chart);
    }

    function drawWidget() {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);
        chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget));

        var labelContainer = $('<div />', {
            'class': 'label-container'
        }).css('text-align', 'center');

        var gauge = drawGauge();

        if (metadata.BackgroundPath) {
            var columns = $(
                '<div style="display: flex; align-items: center;">' +
                    '<div class="logo-and-gauge">' +
                        sprintf('<img src="%s" class="img-responsive widget-logo" />', imageUrl + metadata.BackgroundPath) +
                        gauge[0].outerHTML +
                    '</div>' +
                    '<div class="large-label">' +
                        labelContainer[0].outerHTML +
                    '</div>'+
                '</div>');

            labelContainer = columns.find('.label-container');
            drawLabelValue(labelContainer, labelType);

            chart.append(columns);
        } else {
            drawLabelValue(labelContainer, labelType);
            
            if (labelType != 'simple') {
                chart.append(labelContainer).append(gauge);
            } else {
                chart.append(gauge).append(labelContainer);
            }
        }

        setTimeout(function () {
            setGauge(chart.find('.gauge-cont')); 
        }, 0);

        function drawLabelValue(container, type, count) {
            var text;
            count = count || 0;

            setTimeout(function () {
                if (count >= 100) {
                    return;
                }

                count += 10;
                var valuePercentage = count === 0 ? 0 : (value * (count / 100));

                if (count != 100) {
                    valuePercentage = Math.round(valuePercentage);
                }
                
                if (type == 'percent' || type == 'fraction') {
                    if (type == 'percent') {
                        text = sprintf('<b class="big-num">%.1f%%</b>', valuePercentage * 100);
                    } else {
                        text = sprintf('<b class="big-num">%s</b>/%s', valuePercentage, fractionMaxDisplay);
                    }
                } else if (type == 'simple') {
                    text = sprintf('<b class="simple-num">%s</b>', valuePercentage);
                } else if (type == 'simpleTop') {
                    text = sprintf('<b class="big-num">%s</b>', valuePercentage);
                } else if (type == 'hour') {
                    text = sprintf('<b class="big-num">%s</b>/%s', valuePercentage, 'uur');
                }

                container.empty();
                container.append(text);

                drawLabelValue(container, type, count);
            }, 100);
        }

        function drawGauge() {
            var percent = ((value - min) / (max - min)) * 100;
            if (percent < 0) {
                percent = 0;
            }
            if (percent > 100) {
                percent = 100;
            }
            
            var isBottomLabel = labelsPosition === LABELS_BOTTOM;
            var hasTicks = _.find(colorConfig, {isTick: true}) !== undefined;

            var gaugeClass = 'gauge-cont';
            var pointerClass = 'pointer';
            
            if(hasTicks) {
                gaugeClass += ' gauge-cont-ticks';
            }
            
            if(isBottomLabel) {
                gaugeClass += ' gauge-cont-bottom-label';
                pointerClass += ' pointer-short';
            }
            
            
            var container = $(sprintf(
                '<div class="%s" data-percentage="%.1f">' +
                    '<div class="gauge">' +
                        '<div class="inner"></div>' +
                        '<div class="spinner-cont">' +
                            '<div class="spinner">' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                    '<div class="%s"><div class="pointer-inner"></div></div>' +
                    '<div class="pointer-knob"></div>' +
                '</div>', gaugeClass, percent, pointerClass));
            
            return container;
        }

        function setGauge(g) {
            var percentage = calculatePercentage(g.data('percentage'));
            var degrees = maxDegrees * percentage;
            var pointerDegrees = degrees - 90;
            var spinnerCont = g.find('.spinner-cont');
            var spinner = g.find('.spinner');
            var pointer = g.find('.pointer');
            var hasTicks = g.hasClass('gauge-cont-ticks');
            
            g.find('.inner').remove();
            
            var config = findColorConfigOrDefault(percentage);
            
            performPointerRotation(pointer, pointerDegrees);
            
            if (drawSingleBlock !== true) {    
                var contRoot = spinnerCont.parent();
                
                var configLookupPercentage = percentage * 100;
                var orderedConfigs = _.orderBy(colorConfig, 'start');
                var filteredConfigs = _.filter(orderedConfigs, function (conf) {
                    return conf.start <= configLookupPercentage; 
                });
                
                _.forEach(filteredConfigs, function (conf) {
                    var isLast = conf === _.last(filteredConfigs);

                    if (isLast){
                        var newConf = _.cloneDeep(conf);
                        newConf.start = configLookupPercentage;
                        newConf.isMajorTick = false;
                        newConf.isTick = false;
                        
                        orderedConfigs.splice(
                            _.indexOf(orderedConfigs, conf)  + 1, 
                            0, 
                            newConf
                        );
                    }

                    conf.isReached = true;
                });
            
                _.forEach(orderedConfigs, function (conf, idx) {
                    var spinnerContCopy = spinnerCont.clone();
                    var spinner = spinnerContCopy.find('.spinner');
                    spinner.css(getSpinnerCss(conf));
                    
                    var end = 100;
                    var nextConf = orderedConfigs[idx + 1];
                    
                    if (nextConf) {
                        end = nextConf.start;
                    }
                    
                    var endDegrees = ((end / 100) * maxDegrees);
                    
                    if (conf.isReached) {
                        contRoot.append(spinnerContCopy);
                    } else {
                        contRoot.prepend(spinnerContCopy);
                    }
                        
                    rotate(spinnerContCopy, maxDegrees, 0);
                    
                    if (conf.isTick && conf.isMajorTick) {
                        var spinnerContTickCopy = spinnerContCopy.clone();
                        var tickDisplayContainer = $('<p />');

                        spinnerContTickCopy.addClass('spinner-tick-label-cont');
                        tickDisplayContainer.addClass('spinner-tick-label');
                        
                        //Enddedrees + 5 seems to be the magic number where the label aligns with the tick
                        var spinnerContTickCopyEndDegrees = endDegrees + 5;
                        
                        tickDisplayContainer.text(conf.tickValue);
                        spinnerContTickCopy.html(tickDisplayContainer);
                        
                        //Base offset of 10, with an additional 5px for every character
                        var tickDisplayContainerOffset = 10 + (conf.tickValue.toString().length * 5);
                        
                        tickDisplayContainer.css({'right': tickDisplayContainerOffset + 'px'});
                        
                        //Un-rotate text
                        rotate(tickDisplayContainer, -spinnerContTickCopyEndDegrees);
                        rotate(spinnerContTickCopy, spinnerContTickCopyEndDegrees);

                        contRoot.prepend(spinnerContTickCopy);
                    }

                    setTimeout(function () {
                        rotate(spinnerContCopy, endDegrees, 0);

                        spinnerContCopy.css({
                            'z-index': orderedConfigs.length - idx
                        });
                        
                        if (!hasTicks){
                            spinnerCont.remove();
                        } 
                    }, 1000); 
                });

                spinnerCont
                    .clone()
                    .addClass('spinner-root-cont')
                    .empty()
                    .prependTo(contRoot);
                
                if (labelsPosition === LABELS_BOTTOM){
                    spinnerCont
                        .clone()
                        .addClass('spinner-label-cont')
                        .html(chart.find('.label-container'))
                        .prependTo(contRoot);

                    spinnerCont.remove();
                }
            } else{
                rotate(spinnerCont, maxDegrees, 0);
                spinner.css('background-color', config.color);
                rotate(spinnerCont, degrees, 1000);    
            }
        }
        
        function getSpinnerCss(conf) {
            if (drawFullBlocks === true) {
                return getSpinnerBlockCss(conf);
            }
            
            return getSpinnerBorderCss(conf);
        }
        
        function getSpinnerBorderCss(conf) {
            return {
                'background-color': '#fff',
                'border-color': conf.color,
                'border-style': 'solid',
                'border-width': borderWidth + 'px'
            };
        }
        
        function getSpinnerBlockCss(conf) {
            return {
                'background-color': conf.color,
                'opacity': conf.isReached ? '1' : '0.5'
            };
        }
        
        function performPointerRotation(pointer, pointerDegrees) {
            rotate(pointer, 90, 0);

            setTimeout(function () {
                pointer.css({
                    transform: 'rotate(' + pointerDegrees + 'deg)'
                });
            }, 1000);

            rotate(pointer, pointerDegrees, 1000);
        }

        function rotate(el, degrees, timeout, onComplete) {
            onComplete = onComplete || $.noop;
            
            setTimeout(function () {
                $(el).css('transform', 'rotate(' + degrees + 'deg)');
                
                onComplete();
            }, timeout || 0);
        }

        function calculatePercentage(percent){
            if(invertPointerDirection) {
                percent = 100 - percent;
            }

            return percent / 100;
        }
    }
    
    function findColorConfigOrDefault(percentage) {
        //If no config was found, take the config wtih the lowest start value
        return findColorConfig(percentage * 100) || findColorConfig(_.min(_.map(colorConfig, 'start')));
    }

    function findColorConfig(percent){
        var filteredConfigs = _.filter(colorConfig, function(config){
                return config.start <= percent
            })
            	, max = _.max(_.map(filteredConfigs, 'start'));
        
        return _.find(colorConfig, function(config){
            return config.start === max; 
        });
    }
};